import React, { useState } from 'react';

const FreeTimeModal = ({ onClose, onSubmit, currentTotal }) => {
  const [title, setTitle] = useState('');
  const [hours, setHours] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!title.trim()) {
      alert('Please enter an activity name');
      return;
    }

    const hoursFloat = parseFloat(hours);
    
    if (!hoursFloat || hoursFloat <= 0) {
      alert('Please enter a valid duration');
      return;
    }

    if (currentTotal + hoursFloat > 8) {
      alert(`Cannot add free time. Total would exceed 8 hours (current: ${currentTotal} hrs)`);
      return;
    }

    onSubmit({
      title,
      hours: hoursFloat
    });
  };

  return (
    <div className="modal show">
      <div className="modal-content">
        <div className="modal-header">
          <h2>Add Free Time</h2>
          <span className="close" onClick={onClose}>&times;</span>
        </div>
        <div className="modal-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="freeTimeTitle">Activity Name *</label>
              <input
                type="text"
                id="freeTimeTitle"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="e.g., Lunch Break, Team Meeting"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="freeTimeHours">Duration (hours) *</label>
              <input
                type="number"
                id="freeTimeHours"
                min="0.5"
                max="8"
                step="0.5"
                value={hours}
                onChange={(e) => setHours(e.target.value)}
                placeholder="e.g., 1"
                required
              />
            </div>
          </form>
        </div>
        <div className="modal-footer">
          <button className="btn btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn-submit" onClick={handleSubmit}>
            Add to Plan
          </button>
        </div>
      </div>
    </div>
  );
};

export default FreeTimeModal;
